(function($) {
    $(document).ready(async ($) => {
        /**
         * Sets the height of a "relative positioned" placeholder to fit fixed borvo header height
         * @param $forcedHeaderToSet Optional specific header element to adjust. If ommitted, all visible header.borvo elements will be set
         * @param reset Optional: Reset height to 0?
         */
        window.setFixedBorvoHeaderHeight = function($forcedHeaderToSet, reset) {
            var forcedMode = ($forcedHeaderToSet instanceof $);
            var $headersToSet = forcedMode ?
                $forcedHeaderToSet :
                $('header.borvo:visible');
            $headersToSet.each(function() {
                var $borvoHeader = $(this);
                var $borvoOffsetPlaceholder = $borvoHeader.siblings(
                    '.borvo-offset.js-offset');
                if ($borvoOffsetPlaceholder.length) {
                    var heightToSet = $borvoHeader.height();
                    if (reset || (!forcedMode &&
                        $borvoHeader.closest('.swiper-container').length &&
                        !$borvoHeader.closest('li').
                            hasClass('flex-active-slide'))) heightToSet = 0;
                    $borvoOffsetPlaceholder.height(heightToSet);
                }
            });
        };
        setFixedBorvoHeaderHeight();
        $(window).on('resize', setFixedBorvoHeaderHeight);

        /**
         * Set the height of borvo header if there is a fixed height
         */
        const setBorvoHeaderHeight = function() {
            const borvoElem = document.querySelector(
                '[data-height="borvo-animated-header"]');
            if (borvoElem != null) {
                const borvoContent = document.getElementsByClassName(
                    'borvo__content').item(0);
                const borvoContentHeight = borvoContent.offsetHeight;
                const pullupContent = document.getElementsByClassName(
                    'page-sections pullup-content body > .pageContentWrap').
                    item(0);
                const headbarHeight = window.innerWidth < 1100 ?
                    window.innerWidth < 768 ? 215 : 246 :
                    306; // Height Headbar /w Logo (mobil 215px, tablet 246px, desk 306px)
                const additionalPadding = window.innerWidth < 1100 ?
                    window.innerWidth < 768 ? 50 : 75 :
                    100; // Padding Headline (mobil 50px, tablet 75px, desk 100px)
                const firstPageElem = pullupContent !== null ?
                    pullupContent.querySelector('section') :
                    null;
                const firstPageElemHeight = pullupContent !== null ?
                    firstPageElem.offsetHeight :
                    0;

                // set height of borvo
                let borvoHeight = window.innerWidth < 768 ?
                    borvoContentHeight + headbarHeight + additionalPadding * 2 :
                    firstPageElemHeight / 2 + borvoContentHeight +
                    headbarHeight + additionalPadding * 2;
                borvoElem.style.height = borvoHeight + 'px';
                if (borvoElem.nextElementSibling.classList.contains(
                    'borvo-offset')) borvoElem.nextElementSibling.style.height = borvoHeight +
                    'px';

                // set borvo content position
                borvoContent.style.top = headbarHeight + additionalPadding +
                    'px';

                // set pullup content position
                pullupContent !== null ?
                    pullupContent.style.transform = window.innerWidth < 768 ?
                        'translateY(0px)' :
                        'translateY(-' + firstPageElemHeight / 2 + 'px)' :
                    0;

                // fade in elements, to avoid loading issues
                borvoElem.classList.add('borvo-animated-header--faded-in');
            }
        };
        setBorvoHeaderHeight();
        $(window).on('resize', setBorvoHeaderHeight);
        $(window).on('orientationchange', setBorvoHeaderHeight);
        window.dispatchEvent(new Event('resize'));

        /**
         * Smooth Logo Animation
         * /w GSAP & Lottie
         */
            // Lottie Animation
        const aniContainer = document.getElementById('page-logo-animation');
        const headbar = document.querySelector('.headbar');
        const borvo = document.querySelector('.borvo');
        if (aniContainer) {
            await SystemJS.import('scroll-trigger');
            ScrollLottie({
                target: '#page-logo-animation',
                trigger: borvo ? '.borvo' : null,
                path: aniContainer.getAttribute('dark') == 1 ?
                    '/templates/platforms/startnext/themes/startnext/lottie/logo-white.json' :
                    '/templates/platforms/startnext/themes/startnext/lottie/logo-blue.json',
                duration: 2,
            });
        }

        // gsap Logo Animation
        await SystemJS.import('gsap');
        if (typeof gsap !== 'undefined') {
            await SystemJS.import('scroll-trigger');
            gsap.registerPlugin(ScrollTrigger);
            const largeAnimation = document.querySelector(
                '.headbar__pageLogo--animation-large');
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: borvo ? '.borvo' : null,
                    toggleActions: 'play none reverse reset',
                    start: window.innerWidth < 1100 ?
                        window.innerWidth < 768 ? '45px top' : '45px top' :
                        '45px top',
                    end: window.innerWidth < 1100 ?
                        window.innerWidth < 768 ? '+=100px' : '+=100px' :
                        '+=100px',
                    markers: false, // useful to check scroller start- & end points
                    scrub: .1, // set to .1 for scroll-bound animation
                },
            });
            if (largeAnimation) {
                tl.to('.headbar__claim--large', {
                    opacity: 0,
                    duration: .05,
                }).to('.headbar__pageLogo--animation-large', {
                    y: window.innerWidth < 1100 ?
                        window.innerWidth < 768 ? -110 : -115 :
                        -175,
                    scale: window.innerWidth < 768 ? .65 : .5,
                    duration: .25,
                    ease: Power4.easeOut,
                }).to('.headbar__claim--top', {
                    opacity: 1,
                    delay: .1,
                });
            }
        }

        // Set Logo Colors
        const setLogoColor = () => {
            const headbar = document.getElementsByClassName('headbar');
            const aniContainer = document.getElementById('page-logo-animation');
            if (!aniContainer) return;
            const children = aniContainer.querySelectorAll('[fill]');
            children.forEach((g) => {
                headbar.item(0).classList.contains('headbar--dark') ?
                    g.setAttribute('class', 'white-fill') :
                    g.setAttribute('class', 'dark-fill');
            });
        };
        document.addEventListener('scroll', setLogoColor);
        setInterval(() => setLogoColor(), 10);
        /**
         * // LOGO ANIMATION
         */

        /**
         * CTA Button on Homepage
         */
        const setCTA = () => {
            const ctaBtn = document.getElementById('cta-btn-homepage');
            if (!ctaBtn) return;
            const width = ctaBtn.firstElementChild.getBoundingClientRect().width;
            ctaBtn.setAttribute('width', width);
            ctaBtn.closest('.headerbar__btn').
                classList.
                add('headerbar__btn--loaded');
        };
        setCTA();

        $('#tyToolbar').appendTo('body'); //fixes strange toolbar behavior that occurs when the toolbar is located in #sb-site

        // Burger-Nav Submenu Toggle
        var trigger = $('.js-nav-opener');
        if (trigger.length) {
            trigger.each(function() {
                var that = $(this);
                that.on('click', function() {
                    that.closest('.js-filter-dropdown').toggleClass('active');
                    return false;
                });
            });
        }

        // hide full menu on leaving start page
        window.onbeforeunload = function() {
            setTimeout(function() {
                $('.js-mainnav').addClass('headbar__menu--faded');
            }, 300);
        };

        // Bootstrap Tooltip
        if (typeof $.fn.tooltip === 'function') {
            $(document).tooltip({
                selector: '[data-toggle="tooltip"]',
                container: 'body',
                html: true,
            });
        }

    });

    if (typeof svg4everybody === 'function') svg4everybody();

    // Slidebars
    var slidebars = {
        init() {
            $(document.body).on('click', '.js-show-sb', function(event) {
                // show
                event.preventDefault();
                slidebars.close();
                $('body').
                    addClass('sb-active').
                    addClass('sb-active-' + $(this).attr('data-type')).
                    removeClass('sb-force-repaint');
            });
            $(document.body).
                on('click', '.js-hide-sb, .slidebar-overlay', function(event) {
                    // hide
                    event.preventDefault();
                    slidebars.close();
                    setTimeout(() => {
                        $('body').addClass('sb-force-repaint');
                    }, 400);
                });
        },
        close() {
            $('body').
                removeClass('sb-active').
                removeClass(function(index, className) {
                    return (className.match(/(^|\s)sb-active-\S+/g) || []).join(
                        ' ');
                });
        },
    };
    slidebars.init();

    // Remove Slide up when interface open event is encountered
    const headbar = document.getElementsByClassName('headbar');
    document.addEventListener('interface-open', function() {
        headbar[0].classList.remove('headbar--slide-up');
    });
})(jQuery);
